module.exports = function mt_getrandmax() {
  //  discuss at: https://locutus.io/php/mt_getrandmax/
  // original by: Onno Marsman (https://twitter.com/onnomarsman)
  //   example 1: mt_getrandmax()
  //   returns 1: 2147483647

  return 2147483647
}
